/**
 *
 */
class EventLoaderStore {
    constructor() {
        this.onReadyQueue = [];
        this.onLoadQueue = [];
        this.allPreloadScriptsLoadedQueue = [];
        this.allJavascriptLoadedQueue = [];
    }
    get onReadyFired() {
        return !!this.onReadyEvent;
    }
    get onLoadFired() {
        return !!this.onLoadEvent;
    }
    get allPreloadScriptsLoadedFired() {
        return !!this.allPreloadScriptsLoadedEvent;
    }
    get allJavascriptLoadedFired() {
        return !!this.allJavascriptLoadedEvent;
    }
}

/**
 *
 *
 *
 *
 *
 *
 */
function sortByPriority(queue) {
    return queue.sort((a, b) => {
        return a.priority - b.priority;
    });
}
/*                                                          */
function invokeListener(ev) {
    return (handler) => {
        try {
            handler.fn(ev);
        } /*                  */
        catch (e) {
            Promise.resolve().then(() => {
                throw e;
            });
        }
    };
}
/**
 *
 */
function handleOnReady(ev) {
    /*                                                                                     */
    const store = getStore();
    store.onReadyEvent = ev || {};
    store.onReadyQueue = sortByPriority(store.onReadyQueue);
    store.onReadyQueue.forEach(invokeListener(store.onReadyEvent));
    /*                                      */
    window.o_global.eventQBus?.emitRetain("assets.events.documentReady");
}
/**
 *
 */
function initOnReady() {
    document.addEventListener("DOMContentLoaded", handleOnReady, false);
}
/**
 *
 *
 */
function handleAllJavascriptLoaded(store) {
    store.allJavascriptLoadedComplete = store.onLoadFired && store.allPreloadScriptsLoadedFired;
    if (store.allJavascriptLoadedComplete) {
        store.allJavascriptLoadedQueue = sortByPriority(store.allJavascriptLoadedQueue);
        store.allJavascriptLoadedQueue.forEach((c) => c.fn({}));
    }
    if (store.allJavascriptLoadedComplete && !store.allJavascriptLoadedFired) {
        /*                                      */
        /*                   */
        window.o_global.eventQBus?.emitRetain("assets.events.allJavascriptLoaded");
        store.allJavascriptLoadedEvent = true;
    }
}
/**
 *
 *
 */
let oldOnLoadFunction;
/**
 *
 */
/*                                                                                                             */
function handleOnLoad(ev) {
    /*                                                                                     */
    const store = getStore();
    if (oldOnLoadFunction) {
        oldOnLoadFunction.call(this, ev);
    }
    store.onLoadEvent = ev || {};
    store.onLoadQueue = sortByPriority(store.onLoadQueue);
    store.onLoadQueue.forEach(invokeListener(store.onLoadEvent));
    handleAllJavascriptLoaded(store);
    /*                                      */
    window.o_global.eventQBus?.emitRetain("assets.events.windowLoad", ev);
}
/**
 *
 *
 */
function initOnLoad() {
    oldOnLoadFunction = window.onload;
    window.onload = handleOnLoad;
}
function handleAllPreloadScriptsLoaded(ev) {
    /*                                                                                     */
    const store = getStore();
    store.allPreloadScriptsLoadedEvent = ev || {};
    store.allPreloadScriptsLoadedQueue = sortByPriority(store.allPreloadScriptsLoadedQueue);
    store.allPreloadScriptsLoadedQueue.forEach(invokeListener(store.allPreloadScriptsLoadedEvent));
    handleAllJavascriptLoaded(store);
    /*                                                                                  */
    /*                                                                        */
}
/**
 *
 *
 */
function initAllPreloadScriptsLoaded() {
    /*                                               */
    document.addEventListener("AllScriptsExecuted", handleAllPreloadScriptsLoaded, false);
}
/**
 *
 */
function getStore() {
    if (!window.o_global) {
        window.o_global = {};
    }
    if (!window.o_global.eventLoaderStore) {
        window.o_global.eventLoaderStore = new EventLoaderStore();
        initOnReady();
        initOnLoad();
        initAllPreloadScriptsLoaded();
    }
    return window.o_global.eventLoaderStore;
}

/**
 *
 */
class EventLoader {
    constructor() {
        /**
 *
 */
        this.store = getStore();
    }
    /**
 *
 *
 *
 *
 *
 */
    onReady(priority, fn) {
        if (!this.store.onReadyFired) {
            this.store.onReadyQueue.push({ priority, fn });
        }
        else {
            fn(this.store.onReadyEvent);
        }
    }
    /**
 *
 *
 *
 *
 *
 */
    onLoad(priority, fn) {
        if (!this.store.onLoadFired) {
            this.store.onLoadQueue.push({ priority, fn });
        }
        else {
            fn(this.store.onLoadEvent);
        }
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    onAllPreloadScriptsLoaded(priority, fn) {
        if (!this.store.allPreloadScriptsLoadedFired) {
            this.store.allPreloadScriptsLoadedQueue.push({ priority, fn });
        }
        else {
            fn(this.store.allPreloadScriptsLoadedEvent);
        }
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    onAllJavascriptLoaded(priority, fn) {
        if (!this.store.allJavascriptLoadedComplete) {
            this.store.allJavascriptLoadedQueue.push({ priority, fn });
        }
        else {
            fn({});
        }
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    onAllScriptsExecuted(priority, fn) {
        this.onAllPreloadScriptsLoaded(priority, fn);
    }
}
/**
 *
 *
 */
function eventLoader() {
    return new EventLoader();
}

export { EventLoader, EventLoaderStore, eventLoader };
/*                              */
